<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="datatable_filter float-right">
          <div class="row">
            <div class="col">
              <label>
                <select v-model="callsTableData.length" @change="GET_CALLS($route.params.id)" class="form-control form-control-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-bordered table-responsive-xl table-hover display">
      <thead>
        <tr>
          <th>#</th>
          <th>{{ $t('app.type') }}</th>
          <th>{{ $t('phones.phone') }}</th>
          <th>{{ $t('phones.owner') }}</th>
          <th>{{ $t('calls.user_id') }}</th>
          <th>{{ $t('calls.created_at') }}</th>
          <th>{{ $t('calls.call_status_name') }}</th>
          <th>{{ $t('calls.result_dialog.name') }}</th>
          <th>{{ $t('debts.next_contact_short') }}</th>
          <th>{{ $t('calls.promised_amount') }}</th>
          <th>{{ $t('calls.promised_date') }}</th>
          <th>{{ $t('app.comment') }}</th>
        </tr>
      </thead>
      <tbody>
          <tr v-for="(call, index) in calls" v-if="!loadCalls">
            <td>{{++index}}</td>
            <td>{{ call.type ? call.type.name:''}}</td>
            <td>{{ call.phone ? call.phone.phone:''}}</td>
            <td>
              {{call.phone ? (call.phone.debtor ? call.phone.debtor.fullname : call.phone.contact_face.fullname):''}}<br>
              <span class="badge badge-pill" :class="{'badge-success':call.phone.contact_face, 'badge-info': call.phone.debtor}">{{call.who}}</span>
            </td>
            <td>{{ call.user.firstname}} {{ call.user.lastname }}</td>
            <td>{{ call.created_at | datetimeFormat }}</td>
            <td>{{ call.status ? call.status.name: '' }}</td>
            <td>{{ call.result_dialog ? call.result_dialog.name: '' }}</td>
            <td>{{ call.next_contact | dateFormat }}</td>
            <td>{{ call.promised_payment.amount }}</td>
            <td>{{ call.promised_payment.promised_date | dateFormat }}</td>
            <td>{{ call.comment }}</td>
          </tr>
          <tr v-if="loadCalls">
            <td colspan="12" class="text-center">
              <div class='sk-wave'>
                <div class='sk-rect sk-rect-1'></div>
                <div class='sk-rect sk-rect-2'></div>
                <div class='sk-rect sk-rect-3'></div>
                <div class='sk-rect sk-rect-4'></div>
                <div class='sk-rect sk-rect-5'></div>
              </div>
            </td>
          </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      loadCalls: false
    };
  },
  computed: {
    ...mapGetters([
      'calls',
      'callsTableData',
    ]),
  },
  mounted() {
    this.GET_CALLS(this.$route.params.id);
  },
  methods: {
    ...mapActions([
      'GET_CALLS',
    ]),
  },
  watch: {
    '$route'() {
      this.GET_CALLS(this.$route.params.id);
    },
  },
};
</script>
